<template>
    <div class="d-flex flex-row align-center">
        <v-btn
            icon
            x-small
            @click="incrementDown"
            :disabled="qty === 1"
            color="primary"
        >
            <v-icon>mdi-minus</v-icon>
        </v-btn>
        <v-text-field
            v-model="selectedQty"
            class="qty-input"
            readonly
        ></v-text-field>
        <v-btn
            icon
            x-small
            @click="incrementUp"
            color="primary"
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </div>
</template>

<script>
    export default {
        name: "QtySelector",
        props: [
            'value'
        ],
        data(){
            return {
                qty: 1
            }
        },
        watch: {
            qty: function() {
                this.$emit('input', this.qty)
            },
            value: function(){
                if(parseInt(this.value) !== parseInt(this.selectedQty)){
                    this.selectedQty = this.value
                }
            }
        },
        computed: {
            selectedQty: {
                get(){
                    return this.qty
                },
                set(value){
                    this.qty = parseInt(value);
                }
            }
        },
        methods: {
            incrementDown(){
                this.qty === 1 ? this.qty = 1 : this.qty--
            },
            incrementUp(){
                this.qty++
            }
        }
    }
</script>

<style scoped>
>>>.v-text-field__details{
    display: none;
}

>>>.v-input{
    margin: 0;
    padding: 0;
    width: 2rem;
}

.qty-input >>> input{
    text-align: center !important;
    padding: 0;
    font-size: 1.5rem;
    color: var(--v-primary-base);
    font-weight: bold;
}

>>>.v-input__slot{
    margin-bottom: 0;
}

.qty-input >>> .v-input__slot::before, .v-input__slot::after{
    border-style: none;
    border-width: 0;

}
</style>